import React, { Component } from 'react';
import { Form, FormField, Input, Select, Button, Card, CardContent, Translate } from '$common';

export default class Edit extends Component {

  componentWillMount() {
    // window.Intercom('trackEvent', 'OPENED_PROFILE');
  }

  submitForm(values) {
    // window.Intercom('trackEvent', 'EDITED_PROFILE');
    this.props.onSubmit(values);
  }

  render() {
    const {
      account,
      timeZones,
      languages,
      onSubmit,
      errors,
      roles
    } = this.props;

    return (
      <Card>
        <CardContent>
          <Form onLoad={form => this.form = form} defaults={account} onSubmit={onSubmit} errors={errors}>
            <FormField name="firstName" label={Translate.get('first_name')}>
              <Input />
            </FormField>
            <FormField name="lastName" label={Translate.get('last_name')}>
              <Input />
            </FormField>
            <FormField name="email" label={Translate.get('email')}>
              <Input />
            </FormField>
            <FormField name="locale" label={Translate.get('locale')}>
              <Select options={languages} />
            </FormField>
            <FormField name="timeZone" label={Translate.get('system_timezone')}>
              <Select options={timeZones} />
            </FormField>
            {
              roles ?
                <FormField name="customerRoleId" label={Translate.get('job_title')}>
                  <Select options={roles.map(({ id, name }) => ({ label: name, value: id }))} />
                </FormField>
              : ''
            }
            <Button type="success" block onClick={::this.submitForm} id="live-profile-edit-button">{Translate.get('save_changes')}</Button>
          </Form>
          <br /><br /><br />
          <Form defaults={account} onSubmit={onSubmit} errors={errors}>
            <FormField name="password" label={Translate.get('enter_your_new_password')}>
              <Input type="password" required />
            </FormField>
            <FormField name="passwordConfirmation" label={Translate.get('enter_your_new_password')}>
              <Input type="password" required />
            </FormField>
            <Button type="success" block onClick={::this.submitForm} id="live-password-change-button">{Translate.get('save_changes')}</Button>
          </Form>
        </CardContent>
      </Card>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/account/edit.js